import { FIELD_ID } from 'app/constants/BrowseConstants';

const QUERY_PARAM_KEY = {
  INCLUDE_ALL_LANGUAGES: 'include_translations',
  PAGE: 'page',
  SCOPE: 'searchScope'
};

const serializeFieldId = fieldId => {
  if (fieldId === FIELD_ID.SCOPE) {
    return QUERY_PARAM_KEY.SCOPE;
  }

  return fieldId.toLowerCase();
};

const deserializeQuerystring = (querystring, { includedFieldIds, searchScopes }) => {
  const urlSearchParams = new URLSearchParams(querystring);

  const appliedFilterIdsByFieldId = includedFieldIds.reduce((acc, fieldId) => {
    if (fieldId === FIELD_ID.SCOPE) {
      return acc;
    }

    const serializedFieldId = serializeFieldId(fieldId);

    acc[fieldId] = urlSearchParams.getAll(serializedFieldId);

    return acc;
  }, {});

  const isIncludeAllLanguages = Boolean(urlSearchParams.get(QUERY_PARAM_KEY.INCLUDE_ALL_LANGUAGES));

  const page = urlSearchParams.get(QUERY_PARAM_KEY.PAGE) ?? 1;

  if (includedFieldIds.includes(FIELD_ID.SCOPE)) {
    const candidateScopeId = urlSearchParams.get(QUERY_PARAM_KEY.SCOPE);
    const defaultSearchScopeId =
      (searchScopes.find(searchScope => searchScope.isDefault) || searchScopes[0])?.scopeId ?? null;

    let scopeId = defaultSearchScopeId;
    if (candidateScopeId) {
      scopeId =
        searchScopes.find(searchScope => searchScope.scopeId === candidateScopeId)?.scopeId ?? defaultSearchScopeId;
    }

    appliedFilterIdsByFieldId[FIELD_ID.SCOPE] = [scopeId];
  }

  return {
    appliedFilterIdsByFieldId,
    isIncludeAllLanguages,
    page
  };
};

const serializeQuerystring = (queryState, { includedFieldIds, searchScopes }) => {
  const { appliedFilterIdsByFieldId, isIncludeAllLanguages, page } = queryState;

  const urlSearchParams = new URLSearchParams();

  Object.entries(appliedFilterIdsByFieldId).forEach(([fieldId, filterIds]) => {
    if (fieldId === FIELD_ID.SCOPE) {
      return;
    }

    const serializedFieldId = serializeFieldId(fieldId);

    filterIds.forEach(filterId => {
      urlSearchParams.append(serializedFieldId, filterId);
    });
  });

  if (isIncludeAllLanguages) {
    urlSearchParams.set(QUERY_PARAM_KEY.INCLUDE_ALL_LANGUAGES, 'true');
  }

  if (page > 1) {
    urlSearchParams.set('page', page);
  }

  if (includedFieldIds.includes(FIELD_ID.SCOPE)) {
    const scopeId = appliedFilterIdsByFieldId[FIELD_ID.SCOPE]?.[0];
    const searchScope = searchScopes.find(nextSearchScope => nextSearchScope.scopeId === scopeId);

    if (searchScope && !searchScope.isDefault) {
      urlSearchParams.set(QUERY_PARAM_KEY.SCOPE, searchScope.scopeId);
    }
  }

  return urlSearchParams.toString();
};

export { deserializeQuerystring, serializeFieldId, serializeQuerystring };
